import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Profile from "./views/Profile";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
import NewUrl from "./views/NewUrl";
import Analytics_1 from "./views/analytics/Analytics_1";
import Analytics_2 from "./views/analytics/Analytics_2";
import Analytics_3 from "./views/analytics/Analytics_3";
import ManageUrl from "./views/ManageUrl";

initFontAwesome();

const App = () => {
  const { isLoading, error } = useAuth0();

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Router history={history}>
      <div id="app" className="d-flex flex-column h-100">
        <NavBar />
        <Container className="flex-grow-1 mt-5">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/create-short-url" component={NewUrl} />
            <Route path="/manage-short-url" component={ManageUrl} />
            <Route path="/analytics" component={Analytics_1} />
            <Route path="/analytics_2" component={Analytics_2} />
            <Route path="/analytics_3" component={Analytics_3} />
            <Route path="/profile" component={Profile} />
          </Switch>
        </Container>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
